import { useNavigate } from "react-router-dom";
import { Container, Title, Text, Button, Stack } from "@mantine/core";
import { IconHome } from "@tabler/icons-react";
import "./styles.scss";

const NotFound404 = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found-page">
      <Container size="md" className="not-found-container">
        <Stack gap="xl" align="center" className="not-found-content">
          <div className="not-found-number">
            <span>404</span>
          </div>

          <Title order={1} className="not-found-title">
            Page Not Found
          </Title>

          <Text size="lg" className="not-found-description">
            The page you're looking for seems to have wandered off.
            Let's get you back to verified territory.
          </Text>

          <Button
            size="xl"
            className="not-found-button"
            leftSection={<IconHome size={24} />}
            onClick={() => navigate("/")}
          >
            Back to Home
          </Button>
        </Stack>
      </Container>
    </div>
  );
};

export default NotFound404;
